export default __webpack_public_path__ + "static/media/button_placement__before_after.caf895f5.png";